import React from "react";
import { Select } from "antd";
import "./style.scss";

export default function CustomSelect({ label, placeholder, ...rest }) {
  return (
    <div className="custom-select-container mb-1">
      <div>
        <p>{label}</p>
        <Select
          style={{
            width: "100%",
          }}
          placeholder={placeholder}
          {...rest}
        />
      </div>
    </div>
  );
}
